import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * WordPress dependencies
 */
import { useEffect } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { useNavigationContext } from '../context';
import { useNavigationGroupContext } from '../group/context';
import { useNavigationMenuContext } from '../menu/context';
import { normalizedSearch } from '../utils';
export var useNavigationTreeItem = function useNavigationTreeItem(itemId, props) {
  var _useNavigationContext = useNavigationContext(),
      activeMenu = _useNavigationContext.activeMenu,
      _useNavigationContext2 = _useNavigationContext.navigationTree,
      addItem = _useNavigationContext2.addItem,
      removeItem = _useNavigationContext2.removeItem;

  var _useNavigationGroupCo = useNavigationGroupContext(),
      group = _useNavigationGroupCo.group;

  var _useNavigationMenuCon = useNavigationMenuContext(),
      menu = _useNavigationMenuCon.menu,
      search = _useNavigationMenuCon.search;

  useEffect(function () {
    var isMenuActive = activeMenu === menu;
    var isItemVisible = !search || normalizedSearch(props.title, search);
    addItem(itemId, _objectSpread(_objectSpread({}, props), {}, {
      group: group,
      menu: menu,
      _isVisible: isMenuActive && isItemVisible
    }));
    return function () {
      removeItem(itemId);
    };
  }, [activeMenu, search]);
};
//# sourceMappingURL=use-navigation-tree-item.js.map